<div class="doc-upload-actions" *ngIf="!showCapture && showBackButton">
    <button mat-button class="secondary" (click)="return()">Back to Documents</button>
</div>

<div class="upload-card" [ngClass]="{ hidden: !showBegin }">
    <mat-card>
        <div class="upload-card-body">
            <h2>Passport Booklet</h2>
            <p>Take a photo of the page of your passport that contains your photo and personal information. Make sure to avoid any glare due to lamination.</p>
            <div class="upload-card-actions pdf-column">
                <button class="mobile-view-btn" mat-button type="button" (click)="startImageCapture()">Take Photo</button>
                <input
                    #manualInput
                    type="file"
                    accept="image/*"
                    style="display: none"
                    capture="environment"
                    (change)="onImageCapture($event.target['files'][0])"
                />
            </div>
        </div>
    </mat-card>
</div>

<div [ngClass]="{ hidden: !showPreview }" class="single-upload-preview-wrapper">
    <div class="upload-actions">
        <button mat-button type="button" class="primary" (click)="continue()">Continue</button>
        <button class="secondary" mat-button type="button" (click)="recapture()">Retake</button>
    </div>
    <div class="single-upload-preview-image-wrapper">
        <canvas #uploadPreview id="barcodeUploadPreview"> </canvas>
    </div>
</div>
